const severityRank = (severity) => ({ critical: 0, high: 1, normal: 2, low: 3 })[severity ?? ''] ?? 4;
const outcomeRank = (outcome) => ({ discrepancy: 0, unable_to_verify: 1, match: 3 })[outcome] ?? 2;
function groups(values, key) {
    const result = new Map();
    for (const value of values) {
        const id = key(value);
        const group = result.get(id) ?? [];
        group.push(value);
        result.set(id, group);
    }
    return [...result].map(([key, items]) => ({ key, items }));
}
/** Presentation only: retain every comparison, citation and outcome. */
export function groupComparisonChecks(checks) {
    return groups([...checks].sort((a, b) => Number(a.attention === 'information') -
        Number(b.attention === 'information') ||
        severityRank(a.severity) - severityRank(b.severity) ||
        outcomeRank(a.outcome) - outcomeRank(b.outcome)), (c) => JSON.stringify([c.opening_ref, c.line_ref, c.field]));
}
/** An issue can have several directions/stages; human task records stay distinct. */
export function groupWorkflowExceptions(exceptions) {
    return groups([...exceptions].sort((a, b) => Number(a.state === 'resolved') - Number(b.state === 'resolved') ||
        Number(a.latest_outcome === 'match') -
            Number(b.latest_outcome === 'match') ||
        severityRank(a.severity) - severityRank(b.severity) ||
        outcomeRank(a.latest_outcome) - outcomeRank(b.latest_outcome)), (e) => JSON.stringify([
        e.order_id,
        /^(po|acknowledgement)(:|$)/.test(e.stage) ? 'purchasing' : e.stage,
        e.opening_ref,
        e.line_ref,
        e.field,
    ]));
}
